import React from 'react';
import './Target_goal_calculator.css';

import gg_icon from '../../../../images/logos/gg_logo_icon.png';
import College from '../../../../images/goals/college_fund.png';
import House from '../../../../images/goals/home.png';
import Emergency from '../../../../images/goals/emergency_fund.png';
import Adulting from '../../../../images/goals/adulting_fund.png';
import Future from '../../../../images/goals/future_savings.png';
import Financial from '../../../../images/goals/dollar_signs.png';
import Adventure from '../../../../images/goals/adventure_fund.png';

import {
    computeTargetForGoal,
    DEFAULT_ANSWERS
} from './targetGoalEngine';

const MAX_GOALS = 3;

const GOAL_ITEMS = [
    { id: 'education', label: 'College and Education', img: College },
    { id: 'house', label: 'House Down Payment', img: House },
    { id: 'emergency', label: 'Emergency Fund', img: Emergency },
    { id: 'business', label: 'Business Startup Fund', img: Adulting },
    { id: 'retirement', label: "Kid's Retirement Fund", img: Future },
    { id: 'fire', label: 'FIRE — Early Retirement', img: Financial },
    { id: 'wealth', label: 'Wealth Building', img: Adventure }
];

class Target_goal_calculator extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            phase: 'pick',
            questionGoalIndex: 0,

            kidAge: 5,
            selectedGoals: [],
            goalAnswers: {},

            expectedReturn: 7,

            leadName: '',
            leadEmail: '',
            leadSubmitted: false
        };

        this.toggleGoal = this.toggleGoal.bind(this);
        this.patchGoalAnswers = this.patchGoalAnswers.bind(this);
    }

    getYearsTo21() {
        return Math.max(1, 21 - Number(this.state.kidAge || 0));
    }

    toggleGoal(goalId) {
        const { selectedGoals, goalAnswers } = this.state;
        const isSelected = selectedGoals.includes(goalId);

        if (isSelected) {
            const nextAnswers = { ...goalAnswers };
            delete nextAnswers[goalId];
            this.setState({
                selectedGoals: selectedGoals.filter((g) => g !== goalId),
                goalAnswers: nextAnswers
            });
            return;
        }

        if (selectedGoals.length >= MAX_GOALS) {
            return;
        }

        this.setState({
            selectedGoals: [...selectedGoals, goalId],
            goalAnswers: {
                ...goalAnswers,
                [goalId]: { ...DEFAULT_ANSWERS[goalId] }
            }
        });
    }

    patchGoalAnswers(goalId, partial) {
        const prev = this.state.goalAnswers[goalId] || DEFAULT_ANSWERS[goalId];
        this.setState({
            goalAnswers: {
                ...this.state.goalAnswers,
                [goalId]: { ...prev, ...partial }
            }
        });
    }

    getTargetForGoal(goalId) {
        return computeTargetForGoal(goalId, this.state.goalAnswers[goalId]);
    }

    calculateResults() {
        const years = this.getYearsTo21();
        const annualRate = Number(this.state.expectedReturn) / 100;
        const monthlyRate = annualRate / 12;
        const totalMonths = years * 12;

        const goals = this.state.selectedGoals.map((goalId) => {
            const targetAmount = this.getTargetForGoal(goalId);
            let monthlySavings = 0;

            if (targetAmount > 0) {
                if (monthlyRate === 0) {
                    monthlySavings = targetAmount / totalMonths;
                } else {
                    const growthFactor = Math.pow(1 + monthlyRate, totalMonths) - 1;
                    monthlySavings = targetAmount * (monthlyRate / growthFactor);
                }
            }

            const totalContributions = monthlySavings * totalMonths;
            const investmentGains = Math.max(0, targetAmount - totalContributions);
            const meta = GOAL_ITEMS.find((g) => g.id === goalId);

            return {
                goalId,
                goalLabel: meta ? meta.label : goalId,
                goalImg: meta ? meta.img : null,
                targetAmount,
                monthlySavings,
                yearlySavings: monthlySavings * 12,
                totalContributions,
                investmentGains
            };
        });

        const totalTargetAmount = goals.reduce((sum, g) => sum + g.targetAmount, 0);
        const totalMonthlySavings = goals.reduce((sum, g) => sum + g.monthlySavings, 0);
        const totalYearlySavings = totalMonthlySavings * 12;
        const totalContributions = goals.reduce((sum, g) => sum + g.totalContributions, 0);
        const potentialInvestmentGains = Math.max(0, totalTargetAmount - totalContributions);

        return {
            years,
            goals,
            totalTargetAmount,
            totalMonthlySavings,
            totalYearlySavings,
            totalContributions,
            potentialInvestmentGains
        };
    }

    formatMoney(value) {
        return Number(value || 0).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
        });
    }

    renderOptionRow(label, children) {
        return (
            <div className='target_goal_question_block'>
                <p className='target_goal_label'>{label}</p>
                <div className='target_goal_options_row'>{children}</div>
            </div>
        );
    }

    renderPill(key, selected, label, onClick) {
        return (
            <button
                key={key}
                type='button'
                className={selected ? 'target_goal_pill selected' : 'target_goal_pill'}
                onClick={onClick}
            >
                {label}
            </button>
        );
    }

    renderGoalQuestions(goalId) {
        const a = this.state.goalAnswers[goalId] || DEFAULT_ANSWERS[goalId];
        const meta = GOAL_ITEMS.find((g) => g.id === goalId);

        switch (goalId) {
            case 'education':
                return (
                    <>
                        <div className='target_goal_step_heading'>
                            {meta ? <img src={meta.img} alt='' className='target_goal_step_icon' /> : null}
                            <h2>{meta ? meta.label : 'Education'}</h2>
                        </div>
                        {this.renderOptionRow(
                            'What type of school are you saving for?',
                            <>
                                {this.renderPill('pub', a.schoolType === 'public', 'Public school', () =>
                                    this.patchGoalAnswers('education', { schoolType: 'public' })
                                )}
                                {this.renderPill('priv', a.schoolType === 'private', 'Private school', () =>
                                    this.patchGoalAnswers('education', { schoolType: 'private' })
                                )}
                            </>
                        )}
                        {this.renderOptionRow(
                            'What expenses do you want to help cover?',
                            <>
                                {this.renderPill('tu', a.expenses.tuition, 'Tuition', () =>
                                    this.patchGoalAnswers('education', {
                                        expenses: { ...a.expenses, tuition: !a.expenses.tuition }
                                    })
                                )}
                                {this.renderPill('rb', a.expenses.roomBoard, 'Room & board', () =>
                                    this.patchGoalAnswers('education', {
                                        expenses: { ...a.expenses, roomBoard: !a.expenses.roomBoard }
                                    })
                                )}
                                {this.renderPill('bk', a.expenses.books, 'Books', () =>
                                    this.patchGoalAnswers('education', {
                                        expenses: { ...a.expenses, books: !a.expenses.books }
                                    })
                                )}
                            </>
                        )}
                        {this.renderOptionRow(
                            'What percent of costs do you want to cover?',
                            [50, 75, 100].map((pct) =>
                                this.renderPill(`c${pct}`, a.coverPct === pct, `${pct}%`, () =>
                                    this.patchGoalAnswers('education', { coverPct: pct })
                                )
                            )
                        )}
                        <p className='target_goal_estimate_hint'>
                            Estimated target for this goal:{' '}
                            <strong>{this.formatMoney(this.getTargetForGoal('education'))}</strong>
                        </p>
                    </>
                );

            case 'retirement':
                return (
                    <>
                        <div className='target_goal_step_heading'>
                            {meta ? <img src={meta.img} alt='' className='target_goal_step_icon' /> : null}
                            <h2>{meta ? meta.label : 'Retirement'}</h2>
                        </div>
                        {this.renderOptionRow(
                            'What kind of lifestyle do you want to help your child afford?',
                            <>
                                {this.renderPill('mod', a.lifestyle === 'modest', 'Modest', () =>
                                    this.patchGoalAnswers('retirement', { lifestyle: 'modest' })
                                )}
                                {this.renderPill('com', a.lifestyle === 'comfortable', 'Comfortable', () =>
                                    this.patchGoalAnswers('retirement', { lifestyle: 'comfortable' })
                                )}
                                {this.renderPill('lux', a.lifestyle === 'luxury', 'Luxury', () =>
                                    this.patchGoalAnswers('retirement', { lifestyle: 'luxury' })
                                )}
                            </>
                        )}
                        <label className='target_goal_label' htmlFor='ret_income'>
                            How much annual income do you want to help provide in retirement?
                        </label>
                        <input
                            id='ret_income'
                            className='target_goal_input'
                            type='number'
                            min='20000'
                            step='5000'
                            value={a.desiredIncome}
                            onChange={(e) =>
                                this.patchGoalAnswers('retirement', {
                                    desiredIncome: Number(e.target.value) || 0
                                })
                            }
                        />
                        {this.renderOptionRow(
                            'What percent of the retirement fund do you want to kickstart?',
                            [25, 50, 75, 100].map((pct) =>
                                this.renderPill(`k${pct}`, a.kickstartPct === pct, `${pct}%`, () =>
                                    this.patchGoalAnswers('retirement', { kickstartPct: pct })
                                )
                            )
                        )}
                        <p className='target_goal_estimate_hint'>
                            Estimated target: <strong>{this.formatMoney(this.getTargetForGoal('retirement'))}</strong>
                        </p>
                    </>
                );

            case 'emergency':
                return (
                    <>
                        <div className='target_goal_step_heading'>
                            {meta ? <img src={meta.img} alt='' className='target_goal_step_icon' /> : null}
                            <h2>{meta ? meta.label : 'Emergency'}</h2>
                        </div>
                        {this.renderOptionRow(
                            'What level of emergency savings are you aiming for?',
                            <>
                                {this.renderPill('st', a.level === 'starter', '$1,000 starter', () =>
                                    this.patchGoalAnswers('emergency', { level: 'starter' })
                                )}
                                {this.renderPill('1m', a.level === '1mo', '1 month of living', () =>
                                    this.patchGoalAnswers('emergency', { level: '1mo' })
                                )}
                                {this.renderPill('2m', a.level === '2mo', '2 months', () =>
                                    this.patchGoalAnswers('emergency', { level: '2mo' })
                                )}
                                {this.renderPill('3m', a.level === '3mo', '3 months', () =>
                                    this.patchGoalAnswers('emergency', { level: '3mo' })
                                )}
                                {this.renderPill('4m', a.level === '4mo', '4 months', () =>
                                    this.patchGoalAnswers('emergency', { level: '4mo' })
                                )}
                                {this.renderPill('6m', a.level === '6mo', '6 months', () =>
                                    this.patchGoalAnswers('emergency', { level: '6mo' })
                                )}
                            </>
                        )}
                        <p className='target_goal_fine_print'>
                            Estimates use a sample monthly spend for planning; adjust your real budget as needed.
                        </p>
                        <p className='target_goal_estimate_hint'>
                            Estimated target: <strong>{this.formatMoney(this.getTargetForGoal('emergency'))}</strong>
                        </p>
                    </>
                );

            case 'house':
                return (
                    <>
                        <div className='target_goal_step_heading'>
                            {meta ? <img src={meta.img} alt='' className='target_goal_step_icon' /> : null}
                            <h2>{meta ? meta.label : 'House'}</h2>
                        </div>
                        {this.renderOptionRow(
                            'How much of the house price do you want to provide as a down payment?',
                            [10, 15, 20, 25].map((pct) =>
                                this.renderPill(`d${pct}`, a.downPaymentPct === pct, `${pct}%`, () =>
                                    this.patchGoalAnswers('house', { downPaymentPct: pct })
                                )
                            )
                        )}
                        <label className='target_goal_label' htmlFor='house_price'>
                            What home value are you helping buy?
                        </label>
                        <input
                            id='house_price'
                            className='target_goal_input'
                            type='number'
                            min='100000'
                            step='10000'
                            value={a.houseValue}
                            onChange={(e) =>
                                this.patchGoalAnswers('house', { houseValue: Number(e.target.value) || 0 })
                            }
                        />
                        <p className='target_goal_estimate_hint'>
                            Estimated down payment target:{' '}
                            <strong>{this.formatMoney(this.getTargetForGoal('house'))}</strong>
                        </p>
                    </>
                );

            case 'business':
                return (
                    <>
                        <div className='target_goal_step_heading'>
                            {meta ? <img src={meta.img} alt='' className='target_goal_step_icon' /> : null}
                            <h2>{meta ? meta.label : 'Business'}</h2>
                        </div>
                        {this.renderOptionRow(
                            'How much of starter costs do you want to cover?',
                            [25, 50, 75, 100].map((pct) =>
                                this.renderPill(`bc${pct}`, a.coverPct === pct, `${pct}%`, () =>
                                    this.patchGoalAnswers('business', { coverPct: pct })
                                )
                            )
                        )}
                        {this.renderOptionRow(
                            'Choose a business type (sample starter costs)',
                            <>
                                {this.renderPill('bm', a.amountMode === 'preset' && a.businessPreset === 'art', 'Art & craft — $5k', () =>
                                    this.patchGoalAnswers('business', {
                                        amountMode: 'preset',
                                        businessPreset: 'art'
                                    })
                                )}
                                {this.renderPill('fit', a.amountMode === 'preset' && a.businessPreset === 'fitness', 'Fitness — $7k', () =>
                                    this.patchGoalAnswers('business', {
                                        amountMode: 'preset',
                                        businessPreset: 'fitness'
                                    })
                                )}
                                {this.renderPill('ven', a.amountMode === 'preset' && a.businessPreset === 'vending', 'Vending — $10k', () =>
                                    this.patchGoalAnswers('business', {
                                        amountMode: 'preset',
                                        businessPreset: 'vending'
                                    })
                                )}
                                {this.renderPill('web', a.amountMode === 'preset' && a.businessPreset === 'website', 'Website — $10k', () =>
                                    this.patchGoalAnswers('business', {
                                        amountMode: 'preset',
                                        businessPreset: 'website'
                                    })
                                )}
                                {this.renderPill('ecom', a.amountMode === 'preset' && a.businessPreset === 'ecommerce', 'E‑commerce — $25k', () =>
                                    this.patchGoalAnswers('business', {
                                        amountMode: 'preset',
                                        businessPreset: 'ecommerce'
                                    })
                                )}
                                {this.renderPill('pho', a.amountMode === 'preset' && a.businessPreset === 'photo', 'Photography — $15k', () =>
                                    this.patchGoalAnswers('business', {
                                        amountMode: 'preset',
                                        businessPreset: 'photo'
                                    })
                                )}
                                {this.renderPill('con', a.amountMode === 'preset' && a.businessPreset === 'construction', 'Construction — $50k', () =>
                                    this.patchGoalAnswers('business', {
                                        amountMode: 'preset',
                                        businessPreset: 'construction'
                                    })
                                )}
                                {this.renderPill('ret', a.amountMode === 'preset' && a.businessPreset === 'retail', 'Retail — $100k', () =>
                                    this.patchGoalAnswers('business', {
                                        amountMode: 'preset',
                                        businessPreset: 'retail'
                                    })
                                )}
                                {this.renderPill('food', a.amountMode === 'preset' && a.businessPreset === 'foodtruck', 'Food truck — $115k', () =>
                                    this.patchGoalAnswers('business', {
                                        amountMode: 'preset',
                                        businessPreset: 'foodtruck'
                                    })
                                )}
                            </>
                        )}
                        <p className='target_goal_label'>Or choose your own amount</p>
                        <div className='target_goal_options_row'>
                            {this.renderPill('cust', a.amountMode === 'custom', 'Custom amount', () =>
                                this.patchGoalAnswers('business', { amountMode: 'custom' })
                            )}
                        </div>
                        {a.amountMode === 'custom' ? (
                            <input
                                className='target_goal_input'
                                type='number'
                                min='1000'
                                step='1000'
                                value={a.customAmount}
                                onChange={(e) =>
                                    this.patchGoalAnswers('business', {
                                        customAmount: Number(e.target.value) || 0
                                    })
                                }
                            />
                        ) : null}
                        <p className='target_goal_estimate_hint'>
                            Estimated target: <strong>{this.formatMoney(this.getTargetForGoal('business'))}</strong>
                        </p>
                    </>
                );

            case 'fire':
                return (
                    <>
                        <div className='target_goal_step_heading'>
                            {meta ? <img src={meta.img} alt='' className='target_goal_step_icon' /> : null}
                            <h2>{meta ? meta.label : 'FIRE'}</h2>
                        </div>
                        {this.renderOptionRow(
                            'What age do you want your child to reach financial independence?',
                            [25, 35, 40, 45, 50, 55].map((age) =>
                                this.renderPill(`a${age}`, a.fiAge === age, `${age}`, () =>
                                    this.patchGoalAnswers('fire', { fiAge: age })
                                )
                            )
                        )}
                        {this.renderOptionRow(
                            'What lifestyle should that support (annual spend)?',
                            <>
                                {this.renderPill('fm', a.lifestyle === 'modest', 'Modest — $50k/yr', () =>
                                    this.patchGoalAnswers('fire', { lifestyle: 'modest' })
                                )}
                                {this.renderPill('fc', a.lifestyle === 'comfortable', 'Comfortable — $75k/yr', () =>
                                    this.patchGoalAnswers('fire', { lifestyle: 'comfortable' })
                                )}
                                {this.renderPill('fl', a.lifestyle === 'luxury', 'Luxury — $125k/yr', () =>
                                    this.patchGoalAnswers('fire', { lifestyle: 'luxury' })
                                )}
                            </>
                        )}
                        {this.renderOptionRow(
                            'What percent of the FIRE fund do you want to kickstart?',
                            [25, 50, 75, 100].map((pct) =>
                                this.renderPill(`fk${pct}`, a.kickstartPct === pct, `${pct}%`, () =>
                                    this.patchGoalAnswers('fire', { kickstartPct: pct })
                                )
                            )
                        )}
                        <p className='target_goal_fine_print'>
                            Target uses a simple “25× annual spend” rule for the full FIRE number, then your kickstart %.
                        </p>
                        <p className='target_goal_estimate_hint'>
                            Estimated kickstart target:{' '}
                            <strong>{this.formatMoney(this.getTargetForGoal('fire'))}</strong>
                        </p>
                    </>
                );

            case 'wealth':
                return (
                    <>
                        <div className='target_goal_step_heading'>
                            {meta ? <img src={meta.img} alt='' className='target_goal_step_icon' /> : null}
                            <h2>{meta ? meta.label : 'Wealth building'}</h2>
                        </div>
                        <p className='small_text'>What would you like this fund to provide?</p>
                        <div className='target_goal_wealth_options'>
                            {[
                                {
                                    id: 'literacy',
                                    title: 'Financial literacy & learning',
                                    sub: 'A learning tool to build money skills',
                                    amount: '$5,000'
                                },
                                {
                                    id: 'motivate',
                                    title: 'Motivate future investing',
                                    sub: 'Enough to inspire continued investing',
                                    amount: '$25,000'
                                },
                                {
                                    id: 'extracurricular',
                                    title: 'Extracurriculars & experiences',
                                    sub: 'Vacations, classes, hobbies',
                                    amount: '$50,000'
                                },
                                {
                                    id: 'meals',
                                    title: 'Meals & basics',
                                    sub: 'Help with everyday costs',
                                    amount: '$125,000'
                                },
                                {
                                    id: 'basic',
                                    title: 'Rent & basic life expenses',
                                    sub: 'Strong safety net for core costs',
                                    amount: '$600,000'
                                }
                            ].map((row) => (
                                <button
                                    key={row.id}
                                    type='button'
                                    className={
                                        a.purpose === row.id
                                            ? 'target_goal_wealth_card selected'
                                            : 'target_goal_wealth_card'
                                    }
                                    onClick={() => this.patchGoalAnswers('wealth', { purpose: row.id })}
                                >
                                    <span className='target_goal_wealth_title'>{row.title}</span>
                                    <span className='target_goal_wealth_sub'>{row.sub}</span>
                                    <span className='target_goal_wealth_amt'>{row.amount}</span>
                                </button>
                            ))}
                        </div>
                        <p className='target_goal_estimate_hint'>
                            Estimated target: <strong>{this.formatMoney(this.getTargetForGoal('wealth'))}</strong>
                        </p>
                    </>
                );

            default:
                return null;
        }
    }

    renderPickStep() {
        const count = this.state.selectedGoals.length;
        return (
            <div className='target_goal_card'>
                <h2>Goal Setting Calculator</h2>
                <p className='small_text'>
                    How much should you aim to save for your kids? Start with your goals, answer a few quick questions,
                    and see suggested targets per goal.
                </p>

                <label className='target_goal_label' htmlFor='kid_age'>
                    Your kid&apos;s age
                </label>
                <input
                    id='kid_age'
                    className='target_goal_input'
                    type='number'
                    min='0'
                    max='20'
                    value={this.state.kidAge}
                    onChange={(event) =>
                        this.setState({
                            kidAge: Math.max(0, Math.min(20, Number(event.target.value || 0)))
                        })
                    }
                />

                <div className='target_goal_pick_header'>
                    <p className='target_goal_label'>Select the financial goals you want to save for</p>
                    <span className='target_goal_goal_count'>
                        {count}/{MAX_GOALS} selected — choose up to {MAX_GOALS}
                    </span>
                </div>

                <div className='target_goal_goal_grid'>
                    {GOAL_ITEMS.map((item) => {
                        const selected = this.state.selectedGoals.includes(item.id);
                        const disabled = !selected && count >= MAX_GOALS;
                        return (
                            <button
                                key={item.id}
                                type='button'
                                className={
                                    selected
                                        ? 'target_goal_goal_card selected'
                                        : disabled
                                          ? 'target_goal_goal_card disabled'
                                          : 'target_goal_goal_card'
                                }
                                onClick={() => !disabled && this.toggleGoal(item.id)}
                                disabled={disabled}
                            >
                                <img src={item.img} alt='' className='target_goal_goal_thumb' />
                                <span className='target_goal_goal_label'>{item.label}</span>
                            </button>
                        );
                    })}
                </div>

                <button
                    className='target_goal_cta'
                    type='button'
                    disabled={count === 0}
                    onClick={() => this.setState({ phase: 'questions', questionGoalIndex: 0 })}
                >
                    Next
                </button>
            </div>
        );
    }

    renderQuestionsStep() {
        const idx = this.state.questionGoalIndex;
        const goalId = this.state.selectedGoals[idx];
        const isLast = idx >= this.state.selectedGoals.length - 1;

        return (
            <div className='target_goal_card'>
                <p className='target_goal_progress'>
                    Goal {idx + 1} of {this.state.selectedGoals.length}
                </p>

                {this.renderGoalQuestions(goalId)}

                <label className='target_goal_label top_margin' htmlFor='expected_return'>
                    Expected annual return on savings (%)
                </label>
                <input
                    id='expected_return'
                    className='target_goal_input'
                    type='number'
                    min='0'
                    max='15'
                    step='0.5'
                    value={this.state.expectedReturn}
                    onChange={(event) =>
                        this.setState({
                            expectedReturn: Math.max(0, Math.min(15, Number(event.target.value || 0)))
                        })
                    }
                />

                <div className='button_row'>
                    <button
                        className='target_goal_secondary'
                        type='button'
                        onClick={() => {
                            if (idx === 0) {
                                this.setState({ phase: 'pick' });
                            } else {
                                this.setState({ questionGoalIndex: idx - 1 });
                            }
                        }}
                    >
                        Back
                    </button>
                    <button
                        className='target_goal_cta'
                        type='button'
                        onClick={() => {
                            if (isLast) {
                                this.setState({ phase: 'results' });
                            } else {
                                this.setState({ questionGoalIndex: idx + 1 });
                            }
                        }}
                    >
                        {isLast ? 'See results' : 'Next'}
                    </button>
                </div>
            </div>
        );
    }

    renderResultsStep() {
        const results = this.calculateResults();

        return (
            <div className='target_goal_card'>
                <h2>Results &amp; insights</h2>
                <p className='small_text'>
                    Suggested savings through age 21 at {this.state.expectedReturn}% annual return (illustrative).
                </p>

                <div className='results_grid'>
                    <div className='result_panel'>
                        <p className='tiny_text'>Target yearly savings (all goals)</p>
                        <h3>{this.formatMoney(results.totalYearlySavings)}</h3>
                    </div>
                    <div className='result_panel'>
                        <p className='tiny_text'>Target monthly savings (all goals)</p>
                        <h3>{this.formatMoney(results.totalMonthlySavings)}</h3>
                    </div>
                </div>

                <p className='target_goal_results_line'>
                    <strong>Save {this.formatMoney(results.totalMonthlySavings)} every month</strong> until your kid is
                    21 to work toward these combined targets.
                </p>

                <p>
                    <strong>Total target amount:</strong> {this.formatMoney(results.totalTargetAmount)}
                </p>
                <p>
                    <strong>Total contributions until 21:</strong> {this.formatMoney(results.totalContributions)}
                </p>
                <p>
                    <strong>Potential investment gains:</strong> {this.formatMoney(results.potentialInvestmentGains)}
                </p>

                <div className='goal_breakdown'>
                    {results.goals.map((goal) => (
                        <div key={goal.goalId} className='goal_breakdown_item'>
                            <div className='goal_breakdown_heading'>
                                {goal.goalImg ? (
                                    <img src={goal.goalImg} alt='' className='goal_breakdown_thumb' />
                                ) : null}
                                <p className='bold'>{goal.goalLabel}</p>
                            </div>
                            <p>Target amount: {this.formatMoney(goal.targetAmount)}</p>
                            <p>Monthly savings until 21: {this.formatMoney(goal.monthlySavings)}</p>
                            <p>Yearly savings until 21: {this.formatMoney(goal.yearlySavings)}</p>
                            <p>Contributions until 21: {this.formatMoney(goal.totalContributions)}</p>
                            <p>Potential gains: {this.formatMoney(goal.investmentGains)}</p>
                        </div>
                    ))}
                </div>

                <div className='lead_capture'>
                    <h4>Get your savings breakdown by email</h4>
                    <input
                        className='target_goal_input'
                        type='text'
                        placeholder='Name'
                        value={this.state.leadName}
                        onChange={(event) => this.setState({ leadName: event.target.value })}
                    />
                    <input
                        className='target_goal_input'
                        type='email'
                        placeholder='Email'
                        value={this.state.leadEmail}
                        onChange={(event) => this.setState({ leadEmail: event.target.value })}
                    />
                    <button
                        className='target_goal_cta'
                        type='button'
                        disabled={!this.state.leadName || !this.state.leadEmail}
                        onClick={() => this.setState({ leadSubmitted: true })}
                    >
                        Submit
                    </button>
                    {this.state.leadSubmitted ? (
                        <p className='green_text'>Thanks! We&apos;ll send your breakdown.</p>
                    ) : null}
                </div>

                <div className='button_row'>
                    <button
                        className='target_goal_secondary'
                        type='button'
                        onClick={() =>
                            this.setState({
                                phase: 'questions',
                                questionGoalIndex: Math.max(0, this.state.selectedGoals.length - 1),
                                leadSubmitted: false
                            })
                        }
                    >
                        Edit answers
                    </button>
                    <button
                        className='target_goal_secondary'
                        type='button'
                        onClick={() =>
                            this.setState({
                                phase: 'pick',
                                questionGoalIndex: 0,
                                selectedGoals: [],
                                goalAnswers: {},
                                leadSubmitted: false
                            })
                        }
                    >
                        Start over
                    </button>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className='target_goal_widget_wrapper'>
                {this.state.phase === 'pick' ? this.renderPickStep() : null}
                {this.state.phase === 'questions' ? this.renderQuestionsStep() : null}
                {this.state.phase === 'results' ? this.renderResultsStep() : null}

                <div className='gifting_footer'>
                    <a href='https://www.greatestgiftapp.com' target='_blank' rel='noreferrer'>
                        <img src={gg_icon} alt='gg icon' />
                    </a>
                    <p className='tiny_text'>Greatest Gift</p>
                </div>
            </div>
        );
    }
}

export default Target_goal_calculator;
